import { render, staticRenderFns } from "./StudyQuizQuestionLastWeeks.vue?vue&type=template&id=25305520"
import script from "./StudyQuizQuestionLastWeeks.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionLastWeeks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports